import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const COLORS = [
  "#00008B",
  "#FFBF00",
  "#228B22",
  "#8B0000",
  "#A3008B",
  "#00A395",
  "#A30003",
  "#008B8B",
  "#6A0DAD",
  "#228B22",
];

const StackedBarChart = ({ loanProductsStatistics }) => {
  if (!loanProductsStatistics || loanProductsStatistics.length === 0)
    return null;

  // Extract product keys dynamically (skip the "month" key)
  const productKeys = Object.keys(loanProductsStatistics[0]).filter(
    (key) => key !== "month"
  );

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={loanProductsStatistics}
        margin={{ top: 0, right: 0, left: 0, bottom: 20 }}
      >
        {/*  */}
        <XAxis
          dataKey="month"
          axisLine={{ stroke: "#D9D9D9" }}
          label={{
            value: "Months",
            position: "bottom",
            offset: 0,
            style: { textAnchor: "middle", fontSize: 14 },
          }}
        />
        <YAxis
          axisLine={{ stroke: "#D9D9D9" }}
          label={{
            value: "Number of loans",
            angle: -90,
            position: "insideLeft",
            offset: 15,
            style: { textAnchor: "middle" },
          }}
        />
        <Legend wrapperStyle={{ marginBottom: -20 }} />
        <Tooltip cursor={false} />
        {productKeys.map((key, index) => {
          const formattedName = key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase())
            .trim();

          return (
            <Bar
              key={key}
              dataKey={key}
              stackId="a"
              fill={COLORS[index % COLORS.length]}
              name={formattedName}
            />
          );
        })}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StackedBarChart;
